/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityIssuerResult { 
    /**
     * Did of the Issuer.
     */
    did?: string;
    /**
     * Public Key to verify the credentials Issued. Encoded in Base64 format
     */
    publicKey?: IdentityIssuerResult.PublicKeyEnum;
    /**
     * List of the different properties needed to work with the DLT of the Issuer.
     */
    dltProperties?: { [key: string]: string; };
    /**
     * List of the different properties needed to work with the Issuer.
     */
    issuerProperties?: { [key: string]: string; };
}
export namespace IdentityIssuerResult {
    export type PublicKeyEnum = '[B@4eed2acf';
    export const PublicKeyEnum = {
        B4eed2acf: '[B@4eed2acf' as PublicKeyEnum
    };
}


